<app-form-delegaterights
    [groupList]="groupList"
    [userList]="userList"
    [delegateList]="delegateList"
    (onValidate)="validate($event)"
    (onCancel)="cancel()"
>
</app-form-delegaterights>
